import AuthService from "./auth.service";
import http from "./http-common";

const token = AuthService.getToken();

const insertCompanyPolicy = (data) => {
  return http.post("/CompanyPolicy/AddPolicy", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getAllCompanyPolicies = () => {
  return http.get("/CompanyPolicy/GetPolicy", {
    headers: { Authorization: "Bearer " + token },
  });
};

const getPolicyById = (id) => {
  return http.post("/CompanyPolicy/GetPolicybyid", id, {
    headers: { Authorization: "Bearer " + token },
  });
};

const updateCompanyPolicy = (data) => {
  return http.post("/CompanyPolicy/UpdatePolicy", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const CompanyPolicyService = {
  insertCompanyPolicy,
  updateCompanyPolicy,
  getAllCompanyPolicies,
  getPolicyById,
};

export default CompanyPolicyService;
